import { djangoClientQueryFactory } from "api/client/helpers/queryFactory";
import { paths } from "api/schema/api-schema";
import assert from "assert";
import { ToolSpec } from "types/json-schemas/type_guards";

export const workflowTableGet = djangoClientQueryFactory(
  { method: "get", path: "/library/workflow_table/{id}/" },
  {
    formatInput: (
      id: paths["/library/workflow_table/{id}/"]["get"]["parameters"]["path"]["id"],
    ) => {
      return { params: { path: { id } } };
    },

    formatQueryKey: (p) => {
      return [p];
    },

    handleResponse: (res) => {
      const data = res.data;

      assert(
        data !== undefined,
        "Expected data to be defined when retrieving a run",
      );
      return {
        ...data,
        parameters: data.parameters as unknown as ToolSpec["params"],
      };
    },
  },
);
